import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { goToCheckout } from "../lib/data";
interface BuyButtonProps {
  label?: string;
  className?: string;
}
export function BuyButton({
  label = "Quiero hacer más eficiente mi consultorio",
  className = ""
}: BuyButtonProps) {
  return <button type="button" onClick={goToCheckout} className={`group relative flex w-full items-center justify-center gap-2 rounded-2xl bg-teal-600 px-5 py-4 text-center text-base font-extrabold leading-tight text-white shadow-lg shadow-teal-600/30 transition-all duration-200 hover:bg-teal-700 active:scale-[0.98] ${className}`} data-id="element-39" data-mp="2obn4o32v0qrn">
      <span data-id="element-40" data-mp="3c6y94ap68dn0">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" data-id="element-41" data-mp="379zk26kd6wvo" />
    </button>;
}